import { render, staticRenderFns } from "./TermoAceiteUsuario.vue?vue&type=template&id=6a66eafd&lang=html"
import script from "./TermoAceiteUsuario.vue?vue&type=script&lang=js"
export * from "./TermoAceiteUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports